import * as yup from 'yup'

const addressSchema = yup.object({
    fullname: yup
        .string()
        .required('El nombre completo es obligatorio')
        .min(3, 'El nombre debe tener al menos 3 caracteres')
        .max(100, 'El nombre no puede exceder 100 caracteres'),

    document_type: yup
        .string()
        .required('El tipo de documento es obligatorio')
        .oneOf(['CC', 'CE', 'NIT', 'PP'], 'Tipo de documento inválido'),

    document: yup
        .number()
        .required('El número de documento es obligatorio')
        .positive('El documento debe ser un número positivo')
        .integer('El documento debe ser un número entero')
        .min(100000, 'El documento debe tener al menos 6 dígitos'),

    province: yup
        .string()
        .required('El departamento es obligatorio')
        .min(3, 'El departamento debe tener al menos 3 caracteres')
        .max(50, 'El departamento no puede exceder 50 caracteres'),

    city: yup
        .string()
        .required('La ciudad es obligatoria')
        .min(2, 'La ciudad debe tener al menos 2 caracteres')
        .max(50, 'La ciudad no puede exceder 50 caracteres'),

    neighborhood: yup
        .string()
        .required('El barrio es obligatorio')
        .min(3, 'El barrio debe tener al menos 3 caracteres')
        .max(100, 'El barrio no puede exceder 100 caracteres'),

    street_type: yup
        .string()
        .required('El tipo de vía es obligatorio')
        .oneOf(
            ['Calle', 'Carrera', 'Avenida', 'Diagonal', 'Transversal'],
            'Tipo de vía inválido'
        ),

    street: yup
        .string()
        .required('El nombre de vía es obligatorio')
        .min(1, 'El nombre de vía es obligatorio')
        .max(20, 'El nombre de vía no puede exceder 20 caracteres'),

    number_home: yup
        .string()
        .required('El número es obligatorio')
        .min(1, 'El número es obligatorio')
        .max(20, 'El número no puede exceder 20 caracteres'),

    type_home: yup
        .string()
        .required('El tipo de vivienda es obligatorio')
        .oneOf(
            ['Casa', 'Apartamento', 'Oficina', 'Local'],
            'Tipo de vivienda inválido'
        ),

    phone: yup
        .number()
        .required('El teléfono es obligatorio')
        .positive('El teléfono debe ser un número positivo')
        .integer('El teléfono debe ser un número entero')
        .min(1000000, 'El teléfono debe tener al menos 7 dígitos'),

    postal_code: yup
        .string()
        .required('El código postal es obligatorio')
        .matches(/^\d{6}$/, 'El código postal debe tener exactamente 6 dígitos'),

    additional_references: yup
        .string()
        .max(200, 'Las referencias no pueden exceder 200 caracteres')
        .optional(),
})

export default addressSchema